export const apiConstants = {
  prospectSimulatorSubmission:
    '/submissions/v3/integration/submit/5162497/4c3d3d02-635d-4927-8f50-7f355c5033b3',
  simulatorForm: '/submissions/v3/integration/submit/5162497/b0d01b78-e6e1-4a7d-9b01-b77d27b21ecd',
  prospectForm: '/submissions/v3/integration/submit/5162497/4c9cfaf8-b0b6-4a31-a77d-e9a171cef96e',
};
